module.exports = __webpack_public_path__ + "img/div6-2s.7f81a86b.jpg";